export default "__VITE_ASSET__CU0Id$Nu__"